/**
 * Shared bodyScrollLockOptions for the `body-scroll-lock` library
 * (`assets/body-scroll-lock.js`). Used by Drawer, Popup, Header, and friends
 * when locking the page scroll.
 *
 * Loaded as ES module via importmap alias `@theme/body-scroll-lock-options`.
 */

export const bodyScrollLockOptions = {
  // Page-shift on scroll lock is prevented globally by `scrollbar-gutter: stable`
  // on <html> (base.css). Keep this false so the library does NOT also add
  // padding-right — double compensation would shift content the other way.
  reserveScrollBarGap: false,

  // cssMode swipers scroll NATIVELY (no JS translate). On real iOS the library
  // preventDefault()-uje touchmove whose vertical delta doesn't match the locked
  // scrollable's state, which kills native horizontal panning inside drawers
  // (JS-driven swipers are unaffected — preventDefault cancels only native
  // scrolling, not event delivery to their handlers). Exempt those touches.
  allowTouchMove: (el) => !!el.closest?.('.swiper-css-mode'),
};
